import Pedidos from './Pedidos';

export default Pedidos;
